import { useState, useEffect } from "react";
import {
  createTagCircuito,
  updateTagCircuito,
  deleteTagCircuito,
} from "../tagsCircuitoService";

// Seleção/CRUD de tags POP e Regional de um circuito. As listas em si (`popTags`/
// `regionalTags`) são globais e vêm prontas de fora (buscadas uma vez pelo pai
// 2.3-circuito/index.js) — este hook só cuida do id selecionado por este circuito
// e das operações de criar/editar/excluir tag. Extraído de circuito/index.js
// (etapa 19, passo 2, do plano de melhorias) — mesmo comportamento, sem mudança de payload.
export default function useCircuitoTags({ popTags, regionalTags, data }) {
  const [selectedPopId, setSelectedPopId] = useState(null);
  const [selectedRegionalId, setSelectedRegionalId] = useState(null);

  // Recalcula o id selecionado sempre que a lista (do pai) ou o circuito (data) mudam
  useEffect(() => {
    setSelectedPopId(
      popTags?.find((tag) => tag?.id === data?.pop?.tagId)?.id || null,
    );
    setSelectedRegionalId(
      regionalTags?.find((tag) => tag?.id === data?.regional?.tagId)?.id ||
        null,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [popTags, regionalTags]);

  const handlePopSelect = (tagId) => {
    try {
      setSelectedPopId(tagId);
    } catch (error) {
      console.error("Erro ao selecionar tag:", error);
    }
  };

  const handlePopCreate = async (newTag) => {
    try {
      const criado = await createTagCircuito({ ...newTag, type: "pop" });
      return criado;
    } catch (error) {
      throw error;
    }
  };

  const handleRegionalSelect = (tagId) => {
    try {
      setSelectedRegionalId(tagId);
    } catch (error) {
      console.error("Erro ao selecionar tag:", error);
    }
  };

  const handleRegionalCreate = async (newTag) => {
    try {
      const criado = await createTagCircuito({ ...newTag, type: "regional" });
      return criado;
    } catch (error) {
      throw error;
    }
  };

  const handleTagUpdate = async (updatedTag) => {
    try {
      await updateTagCircuito(updatedTag);
    } catch (error) {
      throw error;
    }
  };

  const handleTagDelete = async (tagId) => {
    try {
      await deleteTagCircuito(tagId);
    } catch (error) {
      throw error;
    }
  };

  return {
    selectedPopId,
    handlePopSelect,
    handlePopCreate,
    selectedRegionalId,
    handleRegionalSelect,
    handleRegionalCreate,
    handleTagUpdate,
    handleTagDelete,
  };
}
